import React from 'react';
import {MRAppRoutes, useMatchedRoute} from '../../../router/routes';
import {useModel} from '../../../../store/model';
import {useScenarioDetail} from '../../../../store/scenario';
import SuspenseNull from '../../../core/Suspense/SuspenseNull';
import {useExecutionSetup} from '../../../../store/executionSetup';
import {useModelInput} from '../../../../store/modelInputs';
import {ModelInputType} from 'hemwb-api';
import ScenarioParametersBuilder from './ScenarioParametersBuilder';
import {useLastValidValue} from '../../../../hooks/useLastValidValue';
import DefaultPage from '../../../layout/common/DefaultPage';

const ScenarioParametersView: React.FC = () => {
  const {modelUuid, scenarioId} = useMatchedRoute(MRAppRoutes.SCENARIO_PARAMETERS_VIEW);

  const model = useModel(modelUuid);
  const _scenario = useScenarioDetail(Number(scenarioId));
  const scenario = useLastValidValue(_scenario);
  const subModel = useExecutionSetup(scenario?.executionSetupId, modelUuid);
  const input = useModelInput(scenario?.executionSetupId);

  if (!model || !subModel || !input || !scenario) {
    return (
      <DefaultPage>
        <SuspenseNull />
      </DefaultPage>
    );
  }

  if (input.type === ModelInputType.JSONTEMPLATE) {
    return (
      <ScenarioParametersBuilder
        model={model}
        subModel={subModel}
        input={input}
        scenario={scenario}
        submitting={false}
      />
    );
  }

  return null;
};

export default ScenarioParametersView;
